import networkSlide from './networkSlide';

let networkslide = new networkSlide();

//---------------------------------------------

//  --  全ページ共通で利用するもの

//---------------------------------------------
export default class commonManager {
    constructor(effect) {

        this.$header;
        this.$loginbutton;
        this.$scrollDown;

        this.$splashShow;
        this.$splashText;

        this.executionType;

        this.$side;
        this.$sideBtn;
        this.$sideAppDl;
        this.sideBtnFlg = false;

        this.$topKvSns;

        this.effect = effect;


    }
    init(pageID,executionType,splash){


        this.executionType = executionType;

        /* 初回読み込みでしか処理しないもの */
        if(this.executionType=="landing"){
            this.$header = document.getElementById("l-header");
        }
        this.$scrollDown = pageID=="top" ? document.getElementById("c-scrolldown") : false;
        this.$topKvSns = pageID=="top" ? document.getElementById("p-top-kv-sns") : false;
        this.$loginbutton = document.getElementById("l-header-submit");


        this.$splashShow = document.querySelectorAll(".js__splash-show");
        this.$splashText = document.querySelectorAll(".js__splash-splittext");

        this.effect.show(this.$splashShow,"set");
        this.effect.splitText(this.$splashText,"set");

        /* fixed UI */
        if(this.$scrollDown) TweenMax.set(this.$scrollDown,{y:100,opacity:0});
        if(this.$loginbutton) TweenMax.set(this.$loginbutton,{y:-100,opacity:0});


        if(pageID=="top"){
            networkslide.init();
        }

        this.$sideBtn = document.getElementById("js__appdl-trigger");
        this.$side = document.getElementById("c-sidebtn");
        this.$sideAppDl = document.getElementById("c-sidebtn-appdl");
        if(this.executionType=="landing") {
            if(this.$topKvSns) TweenMax.set(this.$topKvSns,{ x:-200 });
            TweenMax.set(this.$side,{ x:200 });
        }

        if(pageID=="top"){
            let _delay = '45e2';
            if(!splash){
                _delay = 0;
            }
            setTimeout(()=> {
                if(this.$topKvSns) TweenMax.to(this.$topKvSns,0.8,{ x:0,delay:1 })
                TweenMax.to(this.$side,0.8,{ x:0,delay:1 })
            },_delay);

        }else{
            if(this.$topKvSns) TweenMax.to(this.$topKvSns,0.4,{ x:-200 })
            TweenMax.to(this.$side,0.4,{ x:200 })
        }

        TweenMax.set(this.$sideAppDl,{opacity:0,x:300})
        this.$sideBtn.addEventListener("click",(e)=>{
            e.stopPropagation();
            TweenMax.killTweensOf(this.$sideAppDl);
            if(!this.sideBtnFlg){
                this.sideBtnFlg = true;
                TweenMax.to(this.$sideAppDl,0.4,{opacity:1,x:0})
            }else{
                this.sideBtnFlg = false;
                TweenMax.to(this.$sideAppDl,0.4,{opacity:0,x:300})
            }
        });




        //this.$sideAppDl


    }
    show(splash,scrollInc){

        // console.log("common show")

        let _delay = '45e2';

        if(!splash){
            _delay = 0;
        }
        TweenMax.staggerTo(document.querySelectorAll("#l-kv-contents__inner .stage"),0.001,{opacity:1,ease:Power2.easeOut},0);
        setTimeout(()=> {
            if(this.executionType=="landing") TweenMax.to(this.$header,0.9,{y:0,ease:Power2.easeOut});
            if(this.$scrollDown&&scrollInc<10) TweenMax.to(this.$scrollDown,0.9,{y:0,opacity:1,ease:Power2.easeOut});
            if(this.$loginbutton) TweenMax.to(this.$loginbutton,0.9,{y:0,opacity:1,ease:Power2.easeOut});
            this.effect.show(this.$splashShow,"show");
            this.effect.splitText(document.querySelectorAll(".js__splash-splittext >* >*"),"show");
        },_delay);

    }
    hide(){
        // TweenMax.to(this.$header,0.4,{y:-100,ease:Power2.easeIn});
        if(this.$scrollDown) TweenMax.to(this.$scrollDown,0.4,{y:100,opacity:0,ease:Power2.easeIn});
        if(document.querySelector("#l-kv-contents__inner .stage.is-show")) TweenMax.to(document.querySelector("#l-kv-contents__inner .stage.is-show"),0.2,{opacity:0,ease:Power2.easeOut});
        setTimeout(()=> {
            this.effect.splitText(document.querySelectorAll(".stage-link .js__splittext >* >*"), "out");
            this.effect.show(document.querySelectorAll(".stage-link-hover-sub"), "out");
        },'5e2');
    }
    render(scrollInc){


    }
    resize(){

        this.h = window.innerHeight;
    }
}